@if (showNav && user) {
  <nav
    [ngbCollapse]="wholeNavIsCollapsed"
    [horizontal]="true"
    [animation]="true"
  >
    <!-- Collapse toggle, top-right per mockup 02-chrome -->
    <button
      type="button"
      class="collapse-toggle"
      (click)="toggleCollapse()"
      [class.is-collapsed]="multiNavIsCollapsed"
      title="{{ multiNavIsCollapsed ? 'Expand menu' : 'Collapse menu' }}"
    >
      <i
        class="navToggle bi"
        [ngClass]="{
          'bi-arrow-right-circle': multiNavIsCollapsed,
          'bi-arrow-left-circle': wholeNavIsCollapsed || !multiNavIsCollapsed
        }"
      ></i>
    </button>

    <div class="nav-items">
      @for (item of navMenuItems | keyvalue: preserveMapOrder; track item) {
        @if (!item.value.hide) {
          <div
            class="nav-item-wrap"
            [ngClass]="{
              active: item.value.isSelected,
              'hover-effect': !item.value.isUnSelectable
            }"
          >
            <a
              class="nav-item"
              title="{{ item.value.name }}"
              (click)="menuClicked(item.value)"
            >
              <i
                class="nav-icon {{ 'bi ' + item.value.icon }}"
                aria-hidden="true"
              ></i>
              <div
                class="nav-label-collapse"
                [ngbCollapse]="multiNavIsCollapsed"
                [horizontal]="true"
                [animation]="false"
              >
                <span class="menuItem-name">
                  <span>{{ item.value.name }}</span>
                  @if (item.value.badgeLabel) {
                    <span
                      class="subNavMenu-item--badge"
                      [ngClass]="item.value.badgeClassName"
                    >
                      @if (item.value.badgeIcon) {
                        <i class="bi me-1" [ngClass]="item.value.badgeIcon"></i>
                      }
                      {{ item.value.badgeLabel }}
                    </span>
                  }
                </span>
              </div>
            </a>
            <div
              [ngbCollapse]="item.value.isCollapsed!"
              [animation]="false"
              class="menuItem-content-{{ item.value.name }}"
            >
              @if (item.value.subMenu) {
                <app-nav-sub-menu
                  [subNavMenu]="item.value.subMenu.menuItems"
                ></app-nav-sub-menu>
              }
            </div>
          </div>
        }
      }
    </div>
  </nav>
}
